var map = {
	"./data2020.json": [
		7301,
		301
	],
	"./data2021.json": [
		6970,
		970
	],
	"./data2023.json": [
		1384,
		384
	],
	"./data2024.json": [
		5041,
		41
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8452;
module.exports = webpackAsyncContext;